/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Circle, Polyline, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Cat(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={128}
        y1={192}
        x2={128}
        y2={224}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Circle cx={84} cy={140} r={10} />
      <Circle cx={172} cy={140} r={10} />
      <Line
        x1={128}
        y1={48}
        x2={128}
        y2={88}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Polyline
        points="144 176 128 192 112 176"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Line
        x1={96}
        y1={53.00879}
        x2={96}
        y2={88}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Line
        x1={160}
        y1={53.00879}
        x2={160}
        y2={88}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M32,136V51.31371a8,8,0,0,1,13.65685-5.65686L67.59832,67.59832l-.0003-.00039a102.88019,102.88019,0,0,1,120.804,0l-.00032.00037,21.94147-21.94147A8,8,0,0,1,224,51.31371V136c0,48.60106-42.98066,88-96,88S32,184.60106,32,136Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default Cat;
